"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialiseAppInsightService = exports.initialiseRudderStackService = void 0;
const React = __importStar(require("react"));
const cookies_1 = require("../cookies");
const index_1 = require("../index");
const AppInsightsService_1 = require("./AppInsightsService");
const RudderStackService_1 = require("./RudderStackService");
// This can be used directly in a project to initialise analytics (without the need to use <ProductAnalyticsProvider>)
const initialiseRudderStackService = () => {
    const rudderStackWriteKey = index_1.AppSettings.getRudderStackWriteKey();
    if (rudderStackWriteKey === null) {
        index_1.Log.error("No RudderStack Write Key found - not initialising RudderStack. For local development it's in the local.env file.");
        return;
    }
    if ((0, cookies_1.checkCookiesEnabled)() === false) {
        index_1.Log.info("Cookies not enabled - not initialising RudderStack.");
        return;
    }
    const rudderService = (0, RudderStackService_1.rudderStackService)();
    if (rudderService === null) {
        return;
    }
    rudderService.initialize(rudderStackWriteKey);
};
exports.initialiseRudderStackService = initialiseRudderStackService;
const initialiseAppInsightService = () => {
    try {
        const appInsightsInstrumentationKey = index_1.AppSettings.getApplicationInsightsKey();
        if (!appInsightsInstrumentationKey) {
            index_1.Log.error("No appInsightsInstrumentationKey found - could not initialise AppInsight. For local development it's in the local.env file.");
            return;
        }
        AppInsightsService_1.appInsightsService.initialize(appInsightsInstrumentationKey);
    }
    catch (e) {
        index_1.Log.error("Unexpected error initializing AppInsight", {
            originalException: e,
        });
    }
};
exports.initialiseAppInsightService = initialiseAppInsightService;
/**
 * @deprecated use initialiseRudderStackService or initialiseAppInsightService
 */
class ProductAnalyticsProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appInsightsInitialized: false,
            rudderStackInitialized: false,
        };
    }
    componentDidMount() {
        // AppInsights initialize
        try {
            const appInsightsInstrumentationKey = index_1.AppSettings.getApplicationInsightsKey();
            if (appInsightsInstrumentationKey !== null) {
                if (!Boolean(this.state.appInsightsInitialized) &&
                    Boolean(appInsightsInstrumentationKey)) {
                    AppInsightsService_1.appInsightsService.initialize(appInsightsInstrumentationKey);
                    this.setState({
                        appInsightsInitialized: true,
                    });
                }
            }
            else {
                index_1.Log.info("No appInsightsInstrumentationKey found - not initialising app insights. For local development it's in the local.env file.");
            }
        }
        catch (e) {
            index_1.Log.error("Unexpected error initializing App Insights Service", {
                originalException: e,
            });
        }
        // Cookie free version don't load the SDK but do direct api call
        if (!this.props.cookieFreeRudderstack) {
            // Rudderstack initialize
            try {
                if (!Boolean(this.state.rudderStackInitialized)) {
                    (0, exports.initialiseRudderStackService)();
                }
                this.setState({
                    rudderStackInitialized: true,
                });
            }
            catch (e) {
                index_1.Log.error("Unexpected error initializing RudderStack Service", {
                    originalException: e,
                });
            }
        }
        else {
            // Runnning this temporary (March 2023) to clear existing rudderstack cookies for users
            (0, RudderStackService_1.clearCookies)();
        }
    }
    render() {
        return React.createElement(React.Fragment, null, this.props.children);
    }
}
exports.default = ProductAnalyticsProvider;
//# sourceMappingURL=AnalyticsService.js.map